// extracted by mini-css-extract-plugin
export default {"image__wrapper":"image_image__wrapper__kKilL","image__main":"image_image__main__2iVJb","image__preview":"image_image__preview__nvey4","is_hidden":"image_is_hidden__o4yQi"};